"use client";

import { onlineManager } from "@tanstack/react-query";
import { useSyncExternalStore } from "react";
const SERVER_ONLINE_SNAPSHOT = true;
function subscribeToOnlineStatus(callback: () => void) {
  if (typeof window === "undefined") {
    return () => {};
  }
  window.addEventListener("online", callback);
  window.addEventListener("offline", callback);
  return () => {
    window.removeEventListener("online", callback);
    window.removeEventListener("offline", callback);
  };
}
export function getOnlineStatusSnapshot() {
  if (typeof navigator === "undefined") {
    return SERVER_ONLINE_SNAPSHOT;
  }
  return navigator.onLine;
}
export function useOnlineStatus() {
  return useSyncExternalStore(subscribeToOnlineStatus, getOnlineStatusSnapshot, _temp);
}
function _temp() {
  return SERVER_ONLINE_SNAPSHOT;
}
let onlineManagerBound = false;
export function bindReactQueryOnlineManager() {
  if (onlineManagerBound || typeof window === "undefined") {
    return;
  }
  onlineManagerBound = true;
  onlineManager.setEventListener(setOnline => subscribeToOnlineStatus(() => {
    setOnline(getOnlineStatusSnapshot());
  }));
  onlineManager.setOnline(getOnlineStatusSnapshot());
}